module.exports = __webpack_public_path__ + "grey-triangle.png?d8fa0cfb3df801e57aac068a5e79c935";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/grey-triangle.png
// module id = 622
// module chunks = 0